import React from 'react'
import AboutBanner from '../Components/aboutsection/AboutBanner'
import OurService from '../Components/aboutsection/OurService'
import Milestones from '../Components/aboutsection/Milestones'
import OurHistory from '../Components/aboutsection/OurHistory'
import ImageGrid from '../Components/aboutsection/ImageGrids'

function About() {
  return (
    <>
    <AboutBanner />
    <Milestones />
    <OurHistory />
    <OurService />
    <ImageGrid />
   
    
    </>
  )
}

export default About